const  sfloaterButton = document.createElement("button");
sfloaterButton.id = "clickonme";
sfloaterButton.onclick = function () {
  document.getElementById('popupgame').src = "https://nume-puzzle3.wiplify.com";
  document.getElementById('popupframe').style.display= "block";
  document.getElementById('popupframeover').style.display= "block";

};
document.body.appendChild(sfloaterButton);

const  sfloaterImageButton = document.createElement("img");
sfloaterImageButton.src = "https://res.cloudinary.com/shulgirit/image/upload/v1657533885/wiply/Clients/Nume/BUTTON_1_eegj6o.png";
document.getElementById("clickonme").appendChild(sfloaterImageButton);

const sfloaterWrapper = document.createElement("div");
sfloaterWrapper.id = 'popupframeover';
sfloaterWrapper.onclick = function () {
  document.getElementById('popupgame').src = "";
  document.getElementById('popupframe').style.display= "none";
  document.getElementById('popupframeover').style.display= "none";
};
document.body.appendChild(sfloaterWrapper);

const spopupWrapper = document.createElement("div");
spopupWrapper.id = 'popupframe';
document.getElementById("popupframeover").appendChild(spopupWrapper);
  
const siframe = document.createElement("iframe");
siframe.id = "popupgame";
document.getElementById("popupframe").appendChild(siframe);

const popupClose = document.createElement("button");
popupClose.id = "popupXbutton";
popupClose.innerText = "X";
popupClose.onclick = function () {
  document.getElementById('popupgame').src = "";
  document.getElementById('popupframe').style.display= "none";
  document.getElementById('popupframeover').style.display= "none";
  
};
document.getElementById("popupframe").appendChild(popupClose);


function displayWithUrl(link) {
     if (window.location.search == "?nume-puzzle") {
      if (document.getElementById("popupframe").style.display != 'block' ) {
              document.getElementById('popupgame').src = link;
              document.getElementById('popupframe').style.display = "block";
              document.getElementById('popupframeover').style.display = "block";
              sessionStorage.setItem("popup" ,"showed-up" ) ;
      }
    } 
}


function displayAfterSec(sec,link) {

    setTimeout(function () {
      if (sessionStorage.getItem("popup") === null && document.getElementById("popupframe").style.display != 'block' ) {
      document.getElementById('popupgame').src = link;
      document.getElementById('popupframe').style.display = "block";
      document.getElementById('popupframeover').style.display = "block";
      sessionStorage.setItem("popup" ,"showed-up" ) ;
      }
    }, sec*1000);      
}

function displayExit(link){
  document.addEventListener("mouseleave", function (e) {
    if (e.clientY < 0) {
        if (sessionStorage.getItem("popupleave") === null && document.getElementById("popupframe").style.display != 'block') {
            document.getElementById('popupgame').src = link;
            document.getElementById('popupframe').style.display = "block";
            document.getElementById('popupframeover').style.display = "block";
            sessionStorage.setItem("popupleave", "showed-up");
        }
    }
}, false);
  
 

}
// displayAfterSec(30,"https://nume-puzzle3.wiplify.com");

displayWithUrl("https://nume-puzzle3.wiplify.com");

// displayExit("https://nume-puzzle3.wiplify.com");